import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { AppPath } from '@shared/routes/app-routing.const';
import { RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';

type LogoColor = 'white' | 'dark';
@Component({
    selector: 'companyid-logo',
    imports: [RouterLink, NgOptimizedImage],
    templateUrl: './logo.component.html',
    styleUrl: './logo.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
    public readonly routeHome = AppPath.EMPTY;
    public logoColor = input<LogoColor>('dark');
    public logoPath = computed(() => `icons/${this.logoColor()}-logo.png`);
}
